import { isNil } from 'lodash';

export const isEmptyString = (param: number | string | null | undefined) => {
  return isNil(param) || param === '';
};
